import { BaseRequestQueryParam, HttpResponse } from 'models';
import axiosClient, { handleRequest } from './axiosClient';
import { getLocalStorage } from 'utils/sessionStorage';
import { StakeRequest, StakingVaultResponse, UserStakingResponse } from 'models/stake';

const stakingApi = {
  getStakingVaults: (): Promise<HttpResponse<StakingVaultResponse[]>> => {
    const url = `/wallet/api/staking`;
    return handleRequest(
      axiosClient.get(url, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  getStakingList: (params: BaseRequestQueryParam): Promise<HttpResponse<UserStakingResponse[]>> => {
    const url = `/wallet/api/staking/stake-list`;
    return handleRequest(
      axiosClient.get(url, {
        params,
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  cancelStaking: (userStakingId: number) => {
    const url = `/wallet/api/staking/cancel/${userStakingId}`;
    return handleRequest(
      axiosClient.post(url, null, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  stake: (request: StakeRequest) => {
    const url = `/wallet/api/staking`;
    return handleRequest(
      axiosClient.post(url, request, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  claim: (vaultId: number) => {
    const url = `/wallet/api/staking/claim/${vaultId}`;
    return handleRequest(
      axiosClient.post(url, null, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
};

export default stakingApi;
